import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { NameComponent } from '../../../shared/components/name/name.component';
import { RecPlanSearchService } from '../../rec-plan-search-service';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { PlanRoom2VM, GetRecPlanNameSearchQuery, GetRecPlanNameSearchReportQuery } from '../../../shared/viewmodels/ISearchServiceReg';
import { ReportViewerESService } from '../../../shared/services/report-viewer-es.service';
import { RecSearchService } from '../../../rec-search/rec-search-service';
import { AuthResultVM, SearchFilter } from '../../../shared/viewmodels/ISearchService';
import { take } from 'rxjs/operators';
import CustomStore from 'devextreme/data/custom_store';
import Swal from 'sweetalert2';
import { DatePipe, DecimalPipe } from '@angular/common';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { CCPaymentService } from '../../../shared/services/cc-payment-service';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service';
import { GetSBImagesQuery, SBListDTO } from '../../../shared/viewmodels/ISearchService';
import { DocBasketComponent } from '../../../shared/components/doc-basket/doc-basket.component';

@Component({
  selector: 'app-rec-plan-name-search-grid',
  providers: [RecPlanSearchService, ReportViewerESService, RecSearchService, DatePipe],
  templateUrl: './rec-plan-name-search-grid.component.html',
  styleUrls: ['./rec-plan-name-search-grid.component.css']
})
export class RecPlanNameSearchGridComponent implements OnInit {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(NameComponent, { static: false }) cName: NameComponent;
  public recsresults: any = {};// PlanRoom2VM[];
  public tmprec: PlanRoom2VM;
  public re: string;
  applyFilterTypes: any;
  currentFilter: any;
  showFilterRow: boolean;
  console = console;
  towns: string[] = [];
  doctypes: string[] = [];
  rolename: string;
  appurl: string;
  userInput: any;
  public errorMsg;
  filteredRecordCount: number;
  filtersUsed: string;
  criteria: string;
  showExportBtn: boolean;

  focusedRowKey: number;
  recordCount: number;

  public remoteOps: any = {};
  planId: number;

  totalCost: number = 0;
  paymentMethod: string;
  authResp: AuthResultVM;
  showLoader: boolean;
  @ViewChild(DocBasketComponent, { static: false }) docBasketChild;


  constructor(private service: RecPlanSearchService, private store: Store<AppState>, private router: Router,
    private sanitizer: DomSanitizer, private datepipe: DatePipe, private reportService: ReportViewerESService, @Inject('BASE_URL') baseUrl: string,
    private ccPmtSvc: CCPaymentService, private auth: AuthenticationService, private SBSvc: ShoppingBasketService) {

    this.store.select((state: any) => state).pipe(take(1)).subscribe(data => {
      this.userInput = data;
      for (let city of this.userInput.coresearchdata.city.citytowns[0].citytowns) {
        if (city.isChecked)
          this.towns.push(city.townAbbrev);
      }
      this.planId = Number(data.coresearchdata.planrole.role[0].planroleID)
      switch (this.planId) {
        case 0: {
          this.rolename = "OWNER";
          break;
        }
        case 1: {
          this.rolename = "STREET";
          break;
        }
        case 2: {
          this.rolename = "SURVEYOR";
          break;
        }
        case 3: {
          this.rolename = "LOCAL";
          break;
        }
      }
      this.appurl = baseUrl;

    });



    this.remoteOps = {
      paging: false,
      filtering: false,
      sorting: false,
      grouping: false,
      summary: false
    };


    this.showFilterRow = true;
    this.applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }];

    this.currentFilter = this.applyFilterTypes[0].key;

  }

  ngOnInit() {

    if (localStorage.getItem("machineLocation") == "1") {
      this.showExportBtn = false;
    } else {
      this.showExportBtn = true;
    }

    this.recsresults = new CustomStore({
      key: "planID",
      load: (loadOptions: any) => {
        let getRecPlanNameSearchQuery = new GetRecPlanNameSearchQuery({

          name: this.userInput.coresearchdata.name.name[0].lastcorpName,
          date: this.userInput.coresearchdata.date.date[0].fromDate,
          endDate: this.userInput.coresearchdata.date.date[0].toDate,
          type: this.rolename,
          towns: this.towns
        });
        return this.service.getRecPlanNameSearchResults(getRecPlanNameSearchQuery).toPromise().then(data => {
          this.tmprec = data.recPlanNameSearchRows[0];
          this.recordCount = data.recPlanNameSearchRows.length;
          return {
            data: data.recPlanNameSearchRows,
            totalCount: data.recPlanNameSearchRows.length
          }
        }).catch(error => { throw error });
      }
    });


    //this.getResults(
    //  this.userInput.coresearchdata.name.name[0].name,
    //  this.userInput.coresearchdata.date.date[0].fromDate,
    //  this.userInput.coresearchdata.date.date[0].toDate,
    //  this.rolename,
    //  this.towns);

  }

  onContentReady(e) {
    this.filteredRecordCount = e.component.totalCount();
  }

  openImage(e, planID, book, page, fileDate) {

    console.log('navigate to image ' + planID + ' ' + book + ' ' + page  + ' ' + fileDate);

    let loc = localStorage.getItem("machineLocation")

    //plan search
    //var cutoffDt = new Date('5/1/2017')
    //if (fileDate < cutoffDt) {
    if (this.service.isInPlanFolder(book, page)) {

      const url = this.router.createUrlTree(['rec-plan-name-doc-disp-pg', book, page, planID])
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }
    }
    else {
      //open the plan in recorded doc disp pg
      const url = this.router.createUrlTree(['/rec-address-doc-disp-pg', planID, book, page]);
      const tUrl = this.appurl + url.toString().substring(1);
      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(tUrl, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(tUrl, '_blank');
      }
    }
  }



  getResults(name, fromdate, todate, rolename, towns) {

    let getRecPlanNameSearchQuery = new GetRecPlanNameSearchQuery({

      name: name,
      date: fromdate,
      endDate: todate,
      type: rolename,
      towns: towns
    });

    console.log(`calling getRecNameSearchResults with ${JSON.stringify(getRecPlanNameSearchQuery)}`);
    console.log(`towns: ${towns}`);

    this.service.getRecPlanNameSearchResults(getRecPlanNameSearchQuery).subscribe(result => {

      this.recsresults = result.recPlanNameSearchRows;
      this.recordCount = this.recsresults.length;
    });



  }

  //getRecDoc(docId: number) {
  //  this.service.getRecDoc(docId).subscribe(
  //    data => { this.recdoc = data },
  //    error => { this.errorMsg = error }
  //  );
  //}



  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  onInitialized(e) {

  }

  //Open image in another tab'
  imgClicked(event) {
    if (!this.dataGrid.instance.isRowSelected(event.row.key)) {
      this.dataGrid.instance.selectRows(event.row.key, false);
    }
    // this.nav.visible = false;


  }

  onExpanding(e) {
    this.focusedRowKey = e.component.option("focusedRowIndex");
    this.focusedRowKey = e.key.index;
    e.component.collapseAll(-1);
  }

  assignTypes(filters: SearchFilter[]) {
    if (filters) {
      filters.forEach(fl => {
        if (fl.filterType == 'join') {
          this.assignTypes(fl.filters);
        } else {
          //for (var prop in this.recsresults[0]) {
          //  if (prop == fl.fieldName) {
          //    fl.fieldType = typeof this.recsresults[0][prop];
          //  }
          //}
          for (var prop in this.tmprec) {
            if (prop == fl.fieldName) {
              fl.fieldType = typeof this.tmprec[prop];
            }
          }
        }

      });
    }
  }

  async export() {

    //Swal.fire("Export of search results is coming soon!")
    //return;

    this.filtersUsed = this.dataGrid.instance.getCombinedFilter(true);// [["firstGrantor", "contains", "bed"], "and", ["firstGrantee", "contains", "or"], "and", ["recLandBook", "contains", "3"]];//[[["recordDate", "<", "2000-04-03T04:00:00.000Z"], "or", ["recordDate", ">=", "2000-04-04T04:00:00.000Z"]], "and", ["firstGrantor", "contains", "BED"]];//
    var filters = new Array<string>();
    //var filterExpression = filtersUsed ? JSON.stringify(filtersUsed) : "";
    //console.log(`filterExpression: ${filterExpression}`);
    //var filterObjs = new Array<SearchFilter>();
    //if (filterExpression) {
    //  var filtersOnGrid = SearchFilter.subHelper(filtersUsed, 0);
    //  filterObjs = [...filtersOnGrid];
    //  this.assignTypes(filterObjs);
    //  console.log(`filterObjs: ${JSON.stringify(filterObjs)}`);
    //  //filtersOnGrid.forEach(f => filters.push(JSON.stringify(f)));
    //  //console.log(`filters: ${JSON.stringify(filters)}`);
    //}

    //let query = new GetRecPlanNameSearchReportQuery({
    //  name: this.userInput.coresearchdata.name[0].lastcorpName,
    //  date: this.userInput.coresearchdata.date[0].fromDate,
    //  endDate: this.userInput.coresearchdata.date[0].toDate,
    //  type: this.rolename,
    //  towns: this.towns,
    //  sortBy: new Array<string>(),
    //  sortDirection: "desc",
    //  filterExpression: filterExpression,
    //  filterObjects: [...filterObjs]
    //});

    ////console.log(`query: ${JSON.stringify(query)}`);
    ////console.log(`type: ${this.userInput.amount[0].type}`);
    //this.reportService.getRecPlanNameSearchReport(query).subscribe(repName => {
    //  this.router.navigate([`/report-viewer-plan/${repName.reportName}`]);
    //});

    if (localStorage.getItem("machineLocation") == "0")
      await this.getPaymentMethod();
    else if (localStorage.getItem("machineLocation") == "2")
      this.openExport();

  }

  openExport() {

    var filterExpression = this.filtersUsed ? JSON.stringify(this.filtersUsed) : "";
    console.log(`filterExpression: ${filterExpression}`);
    var filterObjs = new Array<SearchFilter>();
    if (filterExpression) {
      var filtersOnGrid = SearchFilter.subHelper(this.filtersUsed, 0);
      filterObjs = [...filtersOnGrid];
      this.assignTypes(filterObjs);
      console.log(`filterObjs: ${JSON.stringify(filterObjs)}`);
      //filtersOnGrid.forEach(f => filters.push(JSON.stringify(f)));
      //console.log(`filters: ${JSON.stringify(filters)}`);
    }
    let query = new GetRecPlanNameSearchReportQuery({
      name: this.userInput.coresearchdata.name.name[0].lastcorpName,
      date: this.userInput.coresearchdata.date.date[0].fromDate,
      endDate: this.userInput.coresearchdata.date.date[0].toDate,
      type: this.rolename,
      towns: this.towns,
      sortBy: new Array<string>(),
      sortDirection: "desc",
      filterExpression: filterExpression,
      filterObjects: [...filterObjs]
    });

    //console.log(`query: ${JSON.stringify(query)}`);
    //console.log(`type: ${this.userInput.amount[0].type}`);
    this.reportService.getRecPlanNameSearchReport(query).subscribe(repName => {
      this.router.navigate([`/report-viewer-plan/${repName.reportName}`]);
    });
  }

  async getPaymentMethod() {

    //console.log('export mthd');
    this.totalCost = this.service.setExportCost(this.filteredRecordCount);
    let cost = parseFloat(this.totalCost.toString()).toFixed(2);
    let today = this.datepipe.transform(Date.now(), 'MM-dd-yyyy');
    let time = this.datepipe.transform(Date.now(), 'hh:mm a');

    let x = await Swal.fire({
      title: 'Select Payment Method',
      showCancelButton: true,
      allowEnterKey: true,
      html:
        '<br>' +
        'Total Cost for this Export is $' + cost + '<br><br>' +
        'Payment Method<br>' +
        '<input type="radio" id="radio1" name="paymentMethod" style="display: inline-block; text-align: left;" value="1"> Account&nbsp;&nbsp;&nbsp;<input type="radio" id="radio2" name="paymentMethod" style="display: inline-block; text-align: left;" value="2"> Credit Card' +
        '<br><br>*** This export of index data is from a living index database as of the moment ordered and is subject to any corrections of the official record made by the Registry of Deeds.  This export was ordered on ' + today + ' at ' + time
    }).then((result) => {
      this.paymentMethod = $('input[name=paymentMethod]:checked').val().toString();

      if (result.dismiss === undefined) {
        console.log('pmt ' + this.paymentMethod + ' cost ' + this.totalCost);
        if (this.paymentMethod === "1")
          //account payment
          this.checkAccount();
        else if (this.paymentMethod === '2') {
          //credit card processing
          this.processCC();
        }
        else {
          //nothing selected
        }
      }
      else {
        console.log('no dice');
        return;
      }
    });
  }

  async checkAccount() {

    //    let userName = localStorage.getItem('uid');
    //    let guid = localStorage.getItem('guid');

    await this.auth.ValidateGuid();
    console.log(this.auth.guid + ' ' + this.auth.success);
    if (this.auth.success === 0) {
      //not valid, so get login
      await this.auth.getCredentials();
      console.log('auth ' + this.auth.success)
      if (this.auth.success === 0)
        //login unsuccessful - abort
        return;
    }
    if (this.auth.success === 1) {
      //check if money is ok

      const regExp = /,/g;
      let filterString = '';
      if (this.filtersUsed) {
        filterString = this.filtersUsed.toString();
        filterString = filterString.replace(regExp, ' ');
      }
      let sbQuery = new GetSBImagesQuery({
        emailList: false,
        emailAddress: '',
        zipList: false,
        //sBList: sblist,
        credentialGUID: this.auth.guid,
        submissionType: 0,   //this.machineType,
        internalUserID: this.auth.uid,
        internalDescription: 'export',
        optionalPhone: '',
        optionalZipCode: '',
        totalFee: this.totalCost,
        units: this.filteredRecordCount,
        filter: this.criteria + " - Filter - " + filterString
      });

      await this.SBSvc.getSBAuth(sbQuery).toPromise()
        .then(data => {
          this.authResp = data.body;
          //console.log('msg - ' + this.authResp.msg);
          //console.log('keys ' + Object.keys(data.body));
        });

      //(error => { this.error = error }),
      //(() => { console.log('authResp  - '+ this.authResp.success); });

      console.log('post getSBAuth ' + this.authResp.success);

      if (this.authResp.success === 0) {
        Swal.fire('Authorization Failed', this.authResp.msg);
        return;
      }
      else {
        //write data to atransaction for account trans
        await this.SBSvc.saveSBCharge(sbQuery).toPromise()
          .then(data => {
            this.SBSvc.logServiceError('export saveSBCharge - ' + data.body)
          },
            error => {
              //logging here
              //this.error = error;
              this.SBSvc.logServiceError('export saveSBCharge Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
            }
          );

        //all good - open the export window
        this.openExport();
      }
    }
  }

  async processCC() {
    console.log('export processCC');
    this.ccPmtSvc.totAmount = this.totalCost;

    await this.ccPmtSvc.getCreditCardInfo();


    if (this.ccPmtSvc.infoEntered = 1) {

      this.showLoader = true;
      await this.ccPmtSvc.authorizeCard();

      if (this.ccPmtSvc.ccPmt.authCode != '') {
        //success

        let regExp = /,/g;
        let filterString = '';
        if (this.filtersUsed) {
          filterString = this.filtersUsed.toString();
          filterString = filterString.replace(regExp, ' ');
        }
        let sbQuery = new GetSBImagesQuery({
          emailList: false,
          emailAddress: '',
          zipList: false,
          //sBList: sblist,
          credentialGUID: '',  //this.auth.guid,
          submissionType: 0,   //this.machineType,
          internalUserID: '',  //this.auth.uid,
          internalDescription: 'export',
          optionalPhone: '',
          optionalZipCode: '',
          authCode: this.ccPmtSvc.ccPmt.authCode,
          orderId: this.ccPmtSvc.ccPmt.orderId,
          totalFee: this.totalCost,
          units: this.filteredRecordCount,
          filter: this.criteria + " - Filter - " + filterString
        });

        //write data to atransaction 
        await this.ccPmtSvc.completeSBChargeandCCSale(sbQuery).toPromise()
          .then(data => {
            this.SBSvc.logServiceError('export cc saveSBCharge - ' + data.body)
            if (data.body === true) {
              this.ccPmtSvc.resetCCPmt();
              this.showLoader = false;
              this.openExport();
            }
          },
            error => {
              //logging here
              //this.error = error;
              this.SBSvc.logServiceError('export cc saveSBCharge Error - ' + Object.keys(error) + ' ' + error.headers + ' ' + error.name + ' ' + error.message + ' ' + Object.keys(error.error) + ' ' + '  - ' + window.navigator.appName + ' ' + window.navigator.appVersion + ' ' + window.navigator.platform);
            }
          );
      }
    }
    this.showLoader = false;
  }


}
